import { FC, useState } from 'react';
import { Button, Form, Input } from 'antd';
import apiRequests from 'src/utils/api';
import apiRoutes from 'src/utils/apiRoutes';
import { getCurrentCustomer } from 'src/utils/localStorage';

interface StepFourProps {
  previous: () => void;
  next: () => void;
}

const invitationDefinitions = {
  advertising: false,
  creative_package: false,
  leadsie_manage_link: false,
  leadsie_social_link: false,
  login_register: true,
  schedule_call_link: false,
  social_media: false,
  video_production: false,
  website: false,
  welcome_kit: false,
};

const StepFour: FC<StepFourProps> = ({ previous, next }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [inputCount, setInputCount] = useState(3);

  const addEmailField = () => {
    setInputCount(inputCount + 1);
  };

  const sendInvitation = async (email: string) => {
    const currentCustomer = getCurrentCustomer();

    return apiRequests.post(`${apiRoutes.CUSTOMER_INVITE}`, {
      email,
      customer_id: currentCustomer.uuid,
      ...invitationDefinitions,
    });
  };

  const sendInvitations = async () => {
    try {
      const values = (await form.validateFields()) as Record<string, string>;
      const extractedEmails = Object.values(values)
        .filter((v): v is string => typeof v === 'string')
        .map((email) => email.trim())
        .filter((email) => email !== '');

      if (extractedEmails.length === 0) {
        next();
        return;
      }

      setLoading(true);

      await Promise.all(extractedEmails.map(sendInvitation));
      next();
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  return (
    <div className="w-full space-y-6">
      <h4 className="text-center text-2xl font-bold text-primary">
        Invite your team
      </h4>

      <div className="mx-auto w-full min-w-[280px] max-w-[70%] text-left text-gray-500">
        <div className="mb-2 text-primary">
          Enter their emails below to send them an invite
        </div>

        <Form form={form}>
          {Array.from({ length: inputCount }).map((_, i) => (
            <Form.Item
              key={`email-${i}`}
              name={`email-${i}`}
              rules={[
                {
                  type: 'email',
                  message: 'Enter a valid email',
                },
              ]}
            >
              <Input type="email" placeholder="Type an email" />
            </Form.Item>
          ))}
        </Form>

        <div className="mt-2 text-right">
          <Button type="primary" onClick={addEmailField}>
            Add
          </Button>
        </div>
      </div>

      <div className="flex items-center justify-between gap-4">
        <Button onClick={previous}>Back</Button>

        <Button type="primary" loading={loading} onClick={sendInvitations}>
          {loading ? 'Sending...' : 'Continue'}
        </Button>
      </div>
    </div>
  );
};

export default StepFour;
